/*global Ractive, RedmarineUXTemplates, BaseComponent */

var PAGE_LINKS_LARGE = 10,
	PAGE_LINKS_SMALL = 3;

// Add component to Global Ractive object
Ractive.components['ux-pagination'] = BaseComponent.extend({

	template: RedmarineUXTemplates.uxpaginationUxpagination,

	// any default data
	data: {
		largeLinks: PAGE_LINKS_LARGE,
		smallLinks: PAGE_LINKS_SMALL,
		component  : 'ux-pagination'
	},

	pages: function(links) {
		var totalPages   = this.get('pageMax')    || 0,
			pageNumber   = this.get('pageNumber') || 0,
			half         = Math.ceil(links / 2),
			start        = 1,
			size         = links;

		if (pageNumber >= half) {
			start = pageNumber - half + 1;
		}
		if (start + links > totalPages) {
			start = totalPages - links + 1;
		}

		if (size > totalPages) {
			size = totalPages;
		}
		else if (start + size > totalPages) {
			start = totalPages - size + 1;
		}

		if (start < 1) {
			start = 1;
		}

		var pages = [];
		for (var i = start; i < start + size; i++) {
			var distance = 'far';
			if (i === pageNumber) {
				distance = 'current';
			}
			else if (Math.abs(i - pageNumber) === 1 || // page "i" is either side of current page
				// current page is last and page "i" is the 3rd last page
				(pageNumber === totalPages && i === totalPages - 2) ||
				// current page is the first and page "i" is page 3
				(pageNumber === 1 && i === 3)
			) {
				distance = 'near';
			}
			pages.push({
				number: i,
				next: i,
				class: '',
				current: 'page-' + i + (i === pageNumber ? ' current' : '')
			});
		}
		if (pageNumber !== 1) {
			pages.unshift({
				number: '&nbsp;',
				next  : pageNumber - 1,
				class : 'ico ico-arrow-left',
				current: 'page-previous'
			});
		}

		if (pageNumber < totalPages) {
			pages.push({
				number: '&nbsp;',
				next  : pageNumber + 1,
				class : 'ico ico-arrow-right',
				current: 'page-next'
			});
		}

		return pages;
	},

	onrender: function() {
		this.on('setPageNumber', function(event, page) {
			this.set('pageNumber', page)
				.then(function() {
					// refocus on the current page number after rendering
					$(this.find('.pagination-v2')).find('.current:visible').focus();
				}.bind(this));
		}.bind(this));
	},

	computed: {
		smallPages: function() {
			return this.pages(this.get('smallLinks'));
		},
		largePages: function() {
			return this.pages(this.get('largeLinks'));
		}
	}
});
